import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6 10.5c0-.401.028-.794.083-1.175L8 11.243V16.5h5.257l2 2H4v-1l2-2v-5zM9.393 6.979L7.952 5.537l-2.83-2.83a1 1 0 10-1.415 1.414l15.556 15.557a1 1 0 101.415-1.415L9.393 6.98zM16 10.5v.257l2 2V10.5c0-3.07-1.63-5.64-4.5-6.32V3.5c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68a5.884 5.884 0 00-.82.258L11.3 6.056C11.523 6.02 11.757 6 12 6c2.49 0 4 2.02 4 4.5zM12 21.5c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2z",
      fill: "#2d6ded"
    }
  )
), c = t;
export {
  c as default
};
